module.exports = __webpack_public_path__ + "img/gsinginBright.02936f3c.svg";